import React from 'react';
import PropTypes from 'prop-types';
import { Spin, Row, Col } from 'antd';
import ReduxTrasversalNotes from 'containers/fe/ReduxTrasversalNotes.jsx';
import ReduxTrasversalActivities from 'containers/fe/ReduxTrasversalActivities.jsx';
import ReduxTrasversalActions from 'containers/fe/ReduxTrasversalActions.jsx';
import ReduxTrasversalHours from 'containers/fe/ReduxTrasversalHours.jsx';
import ReduxRegistroStatus from 'containers/fe/ReduxRegistroStatus.jsx';


class Trasversale extends React.Component {
  componentDidMount() {
    this.props.loadTrasversal();
  }

  render() {
    const isLoading = !this.props.isLoaded;
    return (
      <div>
        <Spin
          spinning={isLoading || this.props.isEditing || this.props.isSaving}
          tip="Caricamento..."
        >
          <Row gutter={16} className="vmg10">
            <Col span={18}>
              <ReduxTrasversalNotes />
              <ReduxTrasversalActivities />
            </Col>
            <Col span={6}>
              <Row className="vmg10">
                <Col>
                  <ReduxRegistroStatus ctx="trasversal" />
                </Col>
              </Row>
              <Row className="vmg10">
                <Col>
                  <ReduxTrasversalHours />
                </Col>
              </Row>
              <ReduxTrasversalActions />
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}

Trasversale.propTypes = {
  isLoaded: PropTypes.bool,
  isEditing: PropTypes.bool,
  isSaving: PropTypes.bool,
  loadTrasversal: PropTypes.func.isRequired,
};

export { Trasversale };
